import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import ColorSlider from '../ColorSlider/ColorSlider'

const VideoProgressBar = React.forwardRef(
  ({ value, buffered, ...rest }, ref) => {
    const fallbackRef = useRef(null)
    const values = [
      {
        value,
        color: '#8A0000'
      },
      {
        value: buffered,
        color: 'rgba(0,0,0,0.5)'
      }
    ]
    const trackStyles = {
      height: 6
    }
    const thumbStyles = {
      width: 24,
      height: 24,
      background: '#8A0000',
      borderRadius: 12
    }
    return (
      <ColorSlider
        stops={values}
        ref={ref || fallbackRef}
        value={value}
        trackStyles={trackStyles}
        thumbStyles={thumbStyles}
        {...rest}
      />
    )
  }
)

VideoProgressBar.propTypes = {
  value: PropTypes.number,
  buffered: PropTypes.number
}

export default VideoProgressBar
